// Types
import {
  DataFromServerType,
  roadsType,
  subCapitolsType,
} from '../components/display/ShowOT/WorkOrder/types';

type state =
  | 'open'
  | 'managed'
  | 'pending-work'
  | 'work-in-progress'
  | 'pending-validation'
  | 'pending-at-validation'
  | 'validated'
  | 'pending-certification'
  | 'partial'
  | 'annulled'
  | 'end';

type capitol = 'Accident' | 'Entorns de carretera' | 'Altres';

type subCapitol = 'Animals' | 'Senyalització';

export interface Order {
  orderIDs?: string;
  id?: string;
  roid: string;
  name?: string;
  specialTag?: string;
  date?: string | number;
  hour?: string | number;
  creationDate?: string | number;
  registerInitDate?: string | number;
  registerEndDate?: string | number;
  derivedEndDate?: string | null;
  groupInter?: string;
  media?: string;
  sendStatus?: string;
  concession?: string;
  pkInit?: string;
  pkEnd?: string;
  description?: string;
  notes?: string;
  road?: string;
  direction?: string;
  capitol?: capitol;
  subCapitol?: subCapitol;
  predefinedOrder?: string;
  state?: state;
  type?: string;
  capitols?: DataFromServerType[];
  subCapitolsValues?: subCapitolsType[];
  concessions?: DataFromServerType[];
  roadsValues?: roadsType[];
  communicationID?: string;
  genericOrCampaignOrderID?: string;
  actionID?: string;
  team?: string;
}

export enum OrderType {
  Generic = 'generic',
  Communication = 'communication',
  SubOrder = 'subOrder',
  Action = 'action',
  Accident = 'accident',
  SurveillanceRoute = 'surveillanceRoute',
  // V4 PR 1 (2026-04-21): tramo del RV como entidad doble con Order propia.
  // ROID `Tr.<indexExp>.<indexType>.02`. Renderizado via `RouteSegmentOT` en ShowOT.
  RouteSegment = 'routeSegment',
  Campaign = 'campaign',
  Multimedia = 'multimedia',
}

export enum OrderState {
  Open = 'open',
  Managed = 'managed',
  PendingWork = 'pending-work',
  WorkInProgress = 'work-in-progress',
  PendingValidation = 'pending-validation',
  PendingATValidation = 'pending-at-validation', // T66: Estado para validación A.T
  Validated = 'validated',
  PendingCertification = 'pending-certification', // Actions: post-validación, pendiente de cobro a Generalitat
  Partial = 'partial',
  Annulled = 'annulled',
  End = 'end',
  // V4 (2026-04-21): estados específicos del Recorregut de Vigilància (D5).
  // Viven en el mismo enum porque RV es una Order más; el control de qué rol
  // los puede usar se hace vía RBAC + matriz rol×transición (ver rolePermissions.ts).
  InProgress = 'in-progress',
  Paused = 'paused',
}
